// Stessi valori di assets/style/tokens.scss, per il tema MUI (che ha bisogno di colori concreti).
export const ds = {
  ink: "#0F2A37",
  ink2: "#2C4553",
  muted: "#56707C",
  subtle: "#8AA1AC",
  icon: "#6A8592",

  canvas: "#F2F6F8",
  surface: "#FFFFFF",
  surface2: "#F4F8FA",
  surface3: "#F8FAFB",
  hover: "#F0F5F8",
  border: "#DCE6EB",
  borderStrong: "#C5D6DE",
  divider: "#EDF2F5",

  accentSoft: "#E8F3F9",
  accentSoftInk: "#075E8F",
  accentBorder: "#A9D3EA",

  primary: "#0A78B5",
  primaryHover: "#075E8F",

  success: "#1F7A52",
  successSoft: "#E7F4EE",
  successInk: "#1A6645",
  warning: "#DC8B1F",
  warningStrong: "#B54708",
  warningSoft: "#FEF6E7",
  warningInk: "#93370D",
  danger: "#B42318",
  dangerHover: "#912018",
  dangerSoft: "#FFFBFA",
  dangerBorder: "#F2B8B5",
  neutralSoft: "#EEF0F2",
  neutralInk: "#3B4A52",

  shadowPop: "0 12px 28px -18px rgba(15,42,55,.45)",
  shadowHover: "0 18px 36px -22px rgba(15,42,55,.35)",
  shadowModal: "0 24px 60px -20px rgba(15,42,55,.45)",

  font: ['"Hanken Grotesk"', "system-ui", "-apple-system", '"Segoe UI"', "Roboto", "sans-serif"].join(","),
};
